export class ShipFlagCodeModel {
    shipFlagCodeId: number;
    name: string;
    description: string;
    country: any;
    countryId: number;
}



// WEBPACK FOOTER //
// ./src/app/shared/models/ship-flag-code-model.ts